module.exports = __webpack_public_path__ + "static/media/DSC_5954.8ca388c9.jpg";